import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import store from 'setupStore';
import dayjs from 'dayjs';
import 'dayjs/locale/sv';
import { LOCAL_STORE_LANGUAGE } from 'constant';
import App from 'components/App';
import { ErrorListener } from 'containers';
import { loadAirShipModules } from 'utils/pushNotificationUtils';
import reportWebVitals from './reportWebVitals';
import './index.scss';

localStorage.setItem(LOCAL_STORE_LANGUAGE, 'se');
loadAirShipModules(window, document);

dayjs.locale('sv');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <ErrorListener />
        <App />
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          pauseOnHover
          theme="colored"
        />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
